<template>
  <div class="pt-4 sm:pt-0 pr-8 pl-10 sm:px-8">
    <h1 class="text-sm text-white font-bold">Tracking Kapal</h1>
    <div class="py-3">
      <div class="w-full mb-1">
        <div class="flex flex-row items-end mb-1">
          <label class="flex-grow text-xs text-white">Nomor Transmitter</label>
          <div class="flex flex-row justify-end gap-1 mb-1">
            <button
              @click="toRemoveHistory()"
              :disabled="history.total < 1"
              :class="`flex justify-center items-center w-5 h-5 bg-gray-${history.total <= 1 ? '300' : '100'} rounded`"
              title="Hapus Tracking">
              <i class="material-icons text-sm">remove</i>
            </button>
            <button
              @click="toAddHistory()"
              class="flex justify-center items-center w-5 h-5 bg-gray-100 rounded"
              title="Tambah Tracking">
              <i class="material-icons text-sm">add</i>
            </button>
          </div>
        </div>
        <input
          v-model="history.transmitter"
          class="w-full h-full rounded-md text-sm text-gray-500"
          type="text">
      </div>
      <div class="w-full mb-1">
        <label class="text-xs text-white">Tanggal Mulai</label>
        <div class="relative w-full h-8">
          <input
            v-model="history.start"
            class="w-full h-full rounded-md text-sm text-gray-500"
            type="text">
          <input
            @change="selectDateStart($event)"
            class="absolute top-0 right-0 bottom-0 left-0 w-full h-8 rounded-md opacity-0"
            type="datetime-local">
        </div>
      </div>
      <div class="w-full mb-3">
        <label class="text-xs text-white">Tanggal Akhir</label>
        <div class="relative w-full h-8">
          <input
            v-model="history.end"
            class="w-full h-full rounded-md text-sm text-gray-500"
            type="text">
          <input
            @change="selectDateEnd($event)"
            class="absolute top-0 right-0 bottom-0 left-0 w-full h-8 rounded-md opacity-0"
            type="datetime-local">
        </div>
      </div>
      <div class="flex flex-col">
        <button
          v-if="$route.path === '/salmontrack/history'"
          @click="untrack()"
          class="mb-3 flex justify-start items-center"
          type="button">
          <i class="material-icons text-xl text-white">keyboard_arrow_left</i>
          <span class="text-xs text-white">Kembali ke beranda</span>
        </button>
        <div class="flex justify-end items-center gap-1">
          <!-- <button
            @click="download()"
            class="px-1 py-1 w-32 h-8 bg-blue-500 text-white text-xs rounded-md"
            type="button">Export</button> -->
          <button
            @click="track()"
            class="px-1 py-1 w-32 h-8 bg-green-500 text-white text-xs rounded-md"
            type="button">Track</button>
        </div>
      </div>
      <Pagination
        class="justify-end items-end mt-3"
        :offset="history.offset"
        :limit="history.limit"
        :total="history.total"
        :handler="changePage" />
      <div
        v-if="$route.query.transmitter"
        class="flex flex-col">
        <hr class="bg-gray-500 my-5" />
        <div class="flex flex-row gap-3 justify-center items-center">
          <span class="w-3 h-3" style="background: #FF1000"></span>
          <p class="flex-grow text-xs text-white">Kecepatan 0 ~ 1.5 knot</p>
        </div>
        <div class="flex flex-row gap-3 justify-center items-center">
          <span class="w-3 h-3" style="background: #FF9900"></span>
          <p class="flex-grow text-xs text-white">Kecepatan 1.5 ~ 3 knot</p>
        </div>
        <div class="flex flex-row gap-3 justify-center items-center">
          <span class="w-3 h-3" style="background: #EBFF00"></span>
          <p class="flex-grow text-xs text-white">Kecepatan 3 ~ 5 knot</p>
        </div>
        <div class="flex flex-row gap-3 justify-center items-center">
          <span class="w-3 h-3" style="background: #00CA08"></span>
          <p class="flex-grow text-xs text-white">Kecepatan 5 ~ 10000 knot</p>
        </div>
      </div>
    </div>
    <PopupMessage :message="message" />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import libs from '../libs'
import { intlFulldatetime } from '../libs/date'
import PopupMessage from './PopupMessage.vue'
import Pagination from './Pagination.vue'

export default {
  name: 'MenuTracking',
  computed: {
    ...mapGetters([
      'auth',
      'histories',
      'history',
      'message'
    ])
  },
  components: {
    PopupMessage,
    Pagination
  },
  methods: {
    ...mapActions([
      'toInitHistory',
      'toAddHistory',
      'toRemoveHistory'
    ]),
    ...mapMutations([
      'setMessage',
      'setHistories',
      'setHistory',
      'setHistoryStart',
      'setHistoryEnd',
      'setHistoriesStart',
      'setHistoriesEnd',
      'resetHistory',
      'setMapControl',
      'setHistoryOffset'
    ]),
    selectDateStart: function (e) {
      this.setHistoryStart(intlFulldatetime(e.target.value))
    },
    selectDateEnd: function (e) {
      this.setHistoryEnd(intlFulldatetime(e.target.value))
    },
    download: function () {
      let exportUrl = `${window.config.BASEURL}/libs/report/tracking.html?`

      exportUrl += `token=${this.auth.token}`
      exportUrl += `&start=${this.history.start}`
      exportUrl += `&end=${this.history.end}`
      exportUrl += `&transmitter=${this.history.transmitter || null}`

      window.open(
        exportUrl,
        { target: '__blank' }
      )
    },
    track: async function () {
      // set input to current history
      this.setHistories({
        transmitter: this.history.transmitter,
        start: this.history.start,
        end: this.history.end
      })

      // check emptry transmitter
      for (var historyIndex in this.histories) {
        const history = this.histories[historyIndex]

        if (history.transmitter === '') {
          this.setHistoryOffset(history.offset)
          this.setMessage({
            text: 'silahkan isi nomor transmitter terlebih dahulu!',
            status: 400
          })

          return
        }
      }

      if (this.$route.path !== '/salmontrack/history') {
        this.$router.push({
          path: '/salmontrack/history',
          query : {
            transmitter: this.history.transmitter,
            start: this.history.start,
            end: this.history.end
          }
        })
      } else {
        this.toInitHistory()
      }
    },
    untrack: function () {
      this.resetHistory()
      this.setMapControl({ mode: 'main' })
      this.$router.push({ path: '/salmontrack' })
    },
    changePage:  function (page) {
      // set input to current history
      this.setHistories({
        transmitter: this.history.transmitter,
        start: this.history.start,
        end: this.history.end
      })

      this.setHistoryOffset(page.offset)
    }
  },
  mounted: function () {
    if (!this.history.start &&
      !this.history.end) {
      this.toAddHistory()
    }
  }
}
</script>

<style scoped>
input[type="datetime-local"]::-webkit-calendar-picker-indicator {
  background: transparent;
  bottom: 0;
  color: transparent;
  cursor: pointer;
  height: auto;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: auto;
}
</style>
